export default "__VITE_ASSET__ee74ee7d__"